import { PayloadAction } from '@reduxjs/toolkit';
import { handleResponseError } from 'app/rootSaga';
import { AxiosError } from 'axios';
import { CommonResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import eatingWaySettingService from './eatingWaySettingService';
import { eatingWaySettingActions } from './eatingWaySettingSlice';
import { EatingWaySettingListItem } from './models';

function* fetchEatingWaySettingList(action: PayloadAction<{ eatingWayId: number }>) {
  try {
    const response: CommonResponse<EatingWaySettingListItem[]> = yield call(
      eatingWaySettingService.getAll,
      action.payload.eatingWayId
    );
    yield put(eatingWaySettingActions.fetchEatingWaySettingListSuccess(response));
  } catch (e) {
    yield put(eatingWaySettingActions.fetchEatingWaySettingListFailed());
    yield handleResponseError(e as AxiosError);
  }
}

export default function* eatingWaySettingSaga() {
  yield takeLatest(eatingWaySettingActions.fetchEatingWaySettingList.type, fetchEatingWaySettingList);
}
